export const PrincipalApplicationModal = {
  REFERENCE: 'reference',
  CANDIDATE: 'candidate',
  SCORECARD: 'scorecard',
} as const;
